import "./SecurityHero.css";

export default function SecurityHero() {
  return (
    <div id="security-Hero" className="outsourcemainclass">
      <h2 className="heading">DevOps Security & Compliance Services</h2>
      <p className="subheading">
        Protect applications and infrastructure with BastionEx’s DevOps Security
        & Compliance services, embedding security and compliance into every
        DevOps stage without slowing delivery or compromising regulatory
        standards.
      </p>
      <div className="btn">
        <button className="btn1">Let's Discuss Your Project</button>
        <button className="btn2">Let's Discuss Your Project</button>
      </div>
    </div>
  );
}
